import { useContext, useState, useEffect } from 'react';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import http from '../../services/http';
import { endPoints } from '../../utils/constanst';
import DivRow from '../controls/DivRow';
import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';
import Input from '../controls/Input';
import Modal from 'react-modal';
import { customStyles } from '../../utils/constanst';
import { ImgAlert, ImgAlertOk, ImgFileDownload } from '../../svg';

const StepDebitoAutomatico = () => {

    const { poliza, setPoliza } = useContext(CotizadorCRDataContext);
    const [mail, setMail] = useState(poliza.asegurado.email);
    const pageDebito = {
        enrolamiento: 1,
        modalRecibo: 2,
        actualizacionCorreo: 3,
        final: 4,
    }
    const [page, setPage] = useState(pageDebito.enrolamiento);



    const [data, setData] = useState({
        pais: 506,
        viewTerminos: false,
        viewFinalizarDebito: false,
        viewFinalizar: false,
        showDialogPagoSuccess: false,
        showDialogGracias: false,
        showDialogConfirmAddress: true,
        fail: false,
        acepta: undefined,
        tipoTarjeta: undefined,
        banks: []
    });


    const changeHandler = event => setData({ ...data, [event.target.name]: event.target.value });
    const changeHandlerMail = event => setMail(event.target.value);

    useEffect(() => {

        http(endPoints.banks).get()
            .then(banks => {
                setData({ ...data, direccionCobro: '', banks: banks })
            });

    }, []);

    const getBanks = () => {
        if (data.pais === 505) {
            let locals = ['0', '5333', '5334', '5335', '1', '71159', '5387', '5418'];
            return data.banks.filter(x => locals.some(s => s === x.value));
        }
        return data.banks;
    }

    const closeModalFinalizarDebito = () => {
        setData({ ...data, viewFinalizarDebito: false, showDialogConfirmAddress: true });
    };

    const downloadReceipts = () => {
        console.log(poliza)
        setPage(5);
        setPoliza({ ...poliza, loading: true });
        http(endPoints.paymentReceipt(poliza.statusAccount, true)).getWithoutParam().finally(() => {
            setPoliza({ ...poliza, loading: false })
            setPage(pageDebito.modalRecibo);
        });
    }

    const updateEmail = () => {
        let data = {
            Id: poliza.aseguradoId,
            Email: mail
        }
        setPoliza({ ...poliza, loading: true });
        http(endPoints.updateEnteEmail).put(data)
            .then(() => {
                http(endPoints.welcomeNotificationAutoPol(poliza.id)).get();//.finally(() => setPage(pageDebito.final));
            })
            .finally(() => {
                setPoliza({ ...poliza, loading: false });
                setPage(pageDebito.final);
            });
    }



    const downloadPolicy = () => {
        setPoliza({ ...poliza, loading: true });
        http(endPoints.descargarPoliza(poliza.id)).get().finally(() => setPoliza({ ...poliza, loading: false }));
    }


    const handleSubmit = () => {
        let result = document.querySelector('form').reportValidity();

        if (!result)
            return;

        console.log(data);

        if (data.acepta === false)
            setPage(pageDebito.actualizacionCorreo);
        else {
            setPoliza({ ...poliza, loading: true });

            http(endPoints.paymentUpdate).post({
                tarjeta: poliza.pasarela.cardNumber.cardNumber
                , tipoTarjeta: data.tipoTarjeta ? 'TR' : 'TZ'
                , correo: poliza.asegurado.email
                , celular: poliza.asegurado.celular
                , Asegurado: poliza.pasarela.cardHolder
                , Vencimiento: poliza.pasarela.expirationDate
                , Poliza: poliza.cnpoliza,
                transactionId: poliza.transactionId,
                BancoEmisor: data.bancoEmisor,
                Acepta: data.acepta
            }).then(r => {
                //openModalFinalizarDebito();
            }).finally(() => {
                setPoliza({ ...poliza, loading: false });
                setPage(pageDebito.modalRecibo);
            })
        }

    };


    return (
        <div className='layout'>
            {page === pageDebito.enrolamiento &&
                <>
                    <div className="reponsive-width-12">
                        <div>
                            <p className=" txt-center" >¿Acepta la tarjeta que utilizó sea guardada para el pago de las cuotas siguientes?</p>
                        </div>
                    </div>
                    <div className="reponsive-width-12">

                        <SwitchButton value={data.acepta} onClick={value => setData({ ...data, acepta: value })} />
                        <SwitchButton label="Tipo tarjeta"
                            si="Débito" no="Crédito"
                            value={data.tipoTarjeta}
                            isRequired={data.acepta}
                            onClick={value => setData({ ...data, tipoTarjeta: value })} />
                        <InputSelect label='País' value={data.pais} field='pais' dataProvider='paises' onChange={changeHandler} />
                        <InputSelect label='Banco emisor' value={data.bancoEmisor} field='bancoEmisor' dataProvider={getBanks} onChange={changeHandler} containBlank={true} required={data.acepta} />

                    </div>
                    <div className="reponsive-width-12">
                        <p>Recibirá el comprobante del medio de pago a estos <br />datos en caso de haber autorizado el cambio.</p>
                    </div>
                    <div className="align-r">
                        <DivRow width='100%'>
                            <button className="control-button-btn btn-next"
                                type="button"
                                onClick={handleSubmit}
                            >Siguiente</button>
                        </DivRow>
                    </div>
                    <div className="text-right">
                        <p onClick={() => setData({ ...data, viewTerminos: true })} className="a-link">Ver terminos y condiciones</p>
                    </div>
                </>
            }
            {page === pageDebito.actualizacionCorreo &&
                <>
                    <div className="dialog-center-content">
                        <p style={{ fontWeight: 400, fontSize: '18px' }} className="txt-primary">Confirme su método de envío</p>
                    </div>
                    <Input value={'Correo Electrónico'} onChange={changeHandler} classNameInput='txt-center' readOnly={true} />
                    <br />
                    <p style={{ fontSize: '16px', color: '#4D4D4D' }}>Confirmación de Correo Electrónico</p>
                    <Input field='mail' value={mail} onChange={changeHandlerMail} classNameInput='txt-center' />
                    <br />
                    <p style={{ fontSize: '16px', color: '#4D4D4D' }}>Le recordamos que al enviársele su póliza vía correo electrónico debe confirmar el correo para tener su póliza en vigencia.</p>
                    <br />
                    <div className="dialog-center-content">
                        <button onClick={updateEmail} type="button" className="control-button-btn btn-color-primary" >Confirmar</button>
                    </div>
                </>
            }
            {page === pageDebito.final &&
                <div className="fontsize14" style={{ 'padding-left': 50, 'padding-right': 50 }}>
                    <p style={{ fontWeight: 400, fontSize: '18px' }} className="txt-primary txt-center">¡Gracias por confiar en seguro LAFISE!</p>
                    <br></br>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <ImgFileDownload />
                    </div>
                    <br></br>

                    <p style={{ fontWeight: 400, fontSize: '14px', color: '#4D4D4D' }} className="">
                        Le estamos enviando su póliza al correo descrito anteriormente, disfrute de la posibilidad de tener su seguro al instante descargándolo dando click al botón
                    </p>
                    <br></br>
                    <div className="" style={{ display: 'flex', justifyContent: 'start' }}>
                        <button type="button" className="control-button-btn btn-color-primary" onClick={downloadPolicy}>Descargar Póliza</button>
                    </div>
                </div>
            }


            <Modal
                isOpen={data.viewTerminos}
                onRequestClose={() => setData({ ...data, viewTerminos: false })}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
            >
                <div className="dialog-center-content">
                    <div className="fontsize14">
                        <h3 className="h3">Términos y condiciones</h3>

                        <h5 className="lfesm">Actualización de medio de pago</h5>

                        <p>
                            De confirmar la actualización de su medio de pago autoriza a <strong> Seguros LAFISE</strong> a realizar débitos automáticos a la tarjeta indicada en concepto del pago de la prima de la póliza antes descrita y sus renovaciones; así mismo autoriza debitar toda prima originada por adendos, inclusiones, reinstalaciones de suma asegurada, entre otros.
                        </p>

                        <p>
                            En caso que la entidad financiera rechace el débito a tarjeta de crédito/débito, autoriza a dicha entidad para que suministre a <strong> Seguros LAFISE</strong> otra tarjeta autorizada con disponibilidad de saldo.
                        </p>

                        <p>
                            Entiende y acepta que conforme lo establecido en el artículo 78 de la ley 733 "Ley general de Seguros, Reaseguros y Fianzas" debe mantener su póliza al día, de lo contrario, si al momento de la ocurrencia de un siniestro se encuentra en mora, su reclamo no tendrá cobertura.
                        </p>
                    </div>
                </div>

                <div className="dialog-center-content">
                    <button type="button" className="control-button-btn btn-color-primary" onClick={() => setData({ ...data, viewTerminos: false })}>Entendido</button>
                </div>
            </Modal>
            <Modal
                isOpen={page === pageDebito.modalRecibo}
                onRequestClose={closeModalFinalizarDebito}
                style={{ ...customStyles, width: '100%' }}

                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
            >
                <div className="dialog-center-content">
                    <div className="" style={{ 'padding-left': 50, 'padding-right': 50, color: '#4D4D4D' }}>
                        <p className="text-center" style={{ marginTop: '20px', marginBottom: '20px' }}>¡Muchas gracias por aceptar el débito automático de su póliza!</p>

                        <h4 className="text-center">Su pago fue un éxito </h4>
                        <div className="dialog-center-content" style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <ImgAlertOk />
                        </div>
                        <p style={{ fontSize: '14px' }}>
                            A partir de ahora las cuotas de su seguro serán debitadas de la tarjeta ingresada.
                        </p>
                        <p style={{ fontSize: '14px' }}>
                            Le enviaremos el comprobante de la actualización de su medio de pago.
                        </p>
                    </div>
                </div>

                <div className="dialog-center-content" style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px', marginBottom: '20px' }}>
                    <button type="button" style={{ width: '35%', fontSize: '12px' }} className="control-button-btn btn-color-primary" onClick={downloadReceipts}>Descargar recibo</button>
                    <button type="button" style={{ width: '35%', fontSize: '12px' }} className="control-button-btn btn-color-primary" onClick={() => setPage(pageDebito.actualizacionCorreo)}>Siguiente</button>
                </div>

            </Modal>
        </div>
    );
}

export default StepDebitoAutomatico;